document.addEventListener("DOMContentLoaded", () => {
  // const deferredElClicks = document.querySelectorAll('.deferred-media__poster');
  // deferredElClicks.forEach(btn => btn.click());
  // const startedVideos = new WeakSet();
  // let observer = new MutationObserver(() => {
  //   const videos = document.querySelectorAll('.deferred-media video');
  //   videos.forEach(video => {
  //     if (!startedVideos.has(video)) {
  //       try {
  //         video.click();
  //       } catch(e) {}

  //       startedVideos.add(video);
  //     }
  //   });
  // });
  // observer.observe(document.body, {
  //   childList: true,
  //   subtree: true
  // });

  if (typeof Swiper === "undefined") return;
  document.querySelectorAll(".swiper").forEach((swiperEl) => {
    // Skip sliders managed by the Broadcast slider.js engine (e.g. video-reels):
    // they self-initialize with their own Swiper instance/config (centeredSlides).
    // Without this guard custom.js re-inits them with Swiper 11 and breaks centering.
    if (
      swiperEl.closest("video-reels, slideshow-section") ||
      swiperEl.classList.contains("swiper-initialized")
    ) {
      return;
    }
    new Swiper(swiperEl, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 20,

      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },

      pagination: {
        el: swiperEl.querySelector(".swiper-pagination"),
        clickable: true,
      },

      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      },

      breakpoints: {
        576: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        1024: { slidesPerView: 5 },
      },
    });
  });

// popup
  const popupServices = document.getElementById('popup-services');
  if (popupServices) {
    const openPopupServices = () => {
      popupServices.classList.add('active');
      popupServices.hidden = false;
    };
    const closePopupServices = () => {
      popupServices.classList.remove('active');
      popupServices.hidden = true;
      history.replaceState(null, '', window.location.pathname);
    };
    if (window.location.hash === '#popup-services') {
      openPopupServices();
    }
    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#popup-services') {
        openPopupServices();
      } else {
        closePopupServices();
      }
    });
    popupServices.addEventListener('click', (e) => {
      if (e.target === popupServices || e.target.classList.contains('popup-close')) {
        closePopupServices();
      }
    });
  }
  


  

  // Precomanda logic
function DCgetForms() {
  return document.querySelectorAll('product-form');
}
function DCgetVariantData(form) {
  if (!form) return null;
  const input = form.querySelector('input[name="id"]');
  if (!input) return null;
  const variantId = input.value;
  const variantData = window.productVariants?.find(v => v.id == variantId);
  if (!variantData) return null;
  return { form, input, variantId, variantData };
}
function DCformatMoney(cents) {
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents, window.theme?.moneyFormat);
  }
  return (cents / 100).toFixed(2) + ' ' + (window.Shopify?.currency?.active || '');
}
// preorder button
/*
  Precomanda este dezactivata: pe stoc 0 ramane butonul default al temei
  ("Epuizat", disabled), randat de buy-buttons.liquid. Ca sa reactivezi
  precomanda, sterge return-ul de mai jos si repune blocul comentat.
*/
const DC_PREORDER_ENABLED = false;
function DCupdatePreorderButton() {
  if (!DC_PREORDER_ENABLED) return;
  const forms = document.querySelectorAll('product-form');
  if (!forms.length) return;
  forms.forEach((form) => {
    const data = DCgetVariantData(form);
    if (!data) return;
    const { variantData } = data;
    const button = form.querySelector('button[type="submit"]');
    if (!button) return;
    if (!variantData.available) {
      button.disabled = false;
      button.textContent = 'Precomandă';
      button.dataset.preorder = 'true';
    } else {
      button.dataset.preorder = 'false';
    }
  });
}
// variant field
function DCfillVariantField(form) {
  const data = DCgetVariantData(form);
  if (!data) return;
  const { variantId, variantData } = data;
  const field = document.getElementById('variant-field');
  if (!field) return;
  field.value = `${variantData.name} (ID: ${variantId})`;
}
const DCpopup = document.getElementById('popup-comanda');
function DCupdateDescription(form) {
  const data = DCgetVariantData(form);
  if (!data) return;
  const { variantData } = data;
  const desc = document.querySelector('#popup-comanda .description');
  if (!desc) return;
  const priceFormatted = DCformatMoney(variantData.price);
  desc.textContent = `${variantData.name} — ${priceFormatted}`;
}
function DCopenPopup(form) {
  if (!DCpopup) return;
  DCupdateDescription(form);
  DCpopup.removeAttribute('hidden');
  DCpopup.classList.add('active');
}
function DCclosePopup() {
  if (!DCpopup) return;
  DCpopup.setAttribute('hidden', true);
  DCpopup.classList.remove('active');
  history.replaceState(null, '', window.location.pathname);
}
// hash logic
if (window.location.hash === '#popup-comanda') {
  DCopenPopup();
}
window.addEventListener('hashchange', () => {
  window.location.hash === '#popup-comanda' ? DCopenPopup() : DCclosePopup();
});
// variant change
document.addEventListener('change', (e) => {
  if (e.target.matches('input[name="id"], select[name="id"]')) {
    setTimeout(DCupdatePreorderButton, 100);
  }
});
document.addEventListener('submit', (e) => {
  if (!DC_PREORDER_ENABLED) return;
  const form = e.target.closest('product-form');
  if (!form) return;
  const button = form.querySelector('button[type="submit"]');
  if (!button) return;
  if (button.dataset.preorder === 'true') {
    e.preventDefault();
    e.stopPropagation();
    DCfillVariantField(form);
    DCopenPopup(form);
  }
});
if (DCpopup) {
  DCpopup.addEventListener('click', (e) => {
    if (e.target === DCpopup || e.target.classList.contains('popup-close')) {
      DCclosePopup();
    }
  });
}
DCupdatePreorderButton();
// end Precomanda logic

  
  const galleryLightbox = document.querySelector(".custom-gallery");
  if (!galleryLightbox || !lightbox) return;

  if (galleryLightbox) {

    const lightbox = document.getElementById("lightbox");
    const lightboxImg = document.getElementById("lightbox-img");
    const btnClose = lightbox.querySelector(".lightbox-close");
    const btnPrev = lightbox.querySelector(".lightbox-prev");
    const btnNext = lightbox.querySelector(".lightbox-next");

    let currentIndex = 0;
    const images = Array.from(galleryLightbox.querySelectorAll("img")).map(img => img.src);

    function openLightbox(index) {
      currentIndex = index;
      lightbox.style.display = "block";
      lightboxImg.src = images[currentIndex];
    }

    function closeLightbox() {
      lightbox.style.display = "none";
    }

    function changeImage(direction) {
      currentIndex = (currentIndex + direction + images.length) % images.length;
      lightboxImg.src = images[currentIndex];
    }

    // События для картинок
    galleryLightbox.querySelectorAll("img").forEach((img, index) => {
      img.addEventListener("click", () => openLightbox(index));
    });
    // События для кнопок
    btnClose.addEventListener("click", closeLightbox);
    btnPrev.addEventListener("click", (e) => {
      e.stopPropagation();
      changeImage(-1);
    });
    btnNext.addEventListener("click", (e) => {
      e.stopPropagation();
      changeImage(1);
    });
    // Закрытие по клику на фон
    lightbox.addEventListener("click", (e) => {
      if (e.target === lightbox) closeLightbox();
    });
    // Управление клавиатурой
    document.addEventListener("keydown", (e) => {
      if (lightbox.style.display === "block") {
        if (e.key === "Escape") closeLightbox();
        if (e.key === "ArrowLeft") changeImage(-1);
        if (e.key === "ArrowRight") changeImage(1);
      }
    });
  }

});